export const SchwabHowItWorks: React.FC = () => {
  return (
    <div>
      <ul>
        <li>Sync your Schwab accounts and client data with Zocks contacts</li>
        <li>Prepare for meetings using live custodial data from Schwab, combined with your connected systems</li>
        <li>Monitor account health, balances, and alerts at a glance</li>
        <li>Get instant insights from Schwab with the Ask Anything AI Assistant</li>
        <li>Generate email replies based on Schwab custodial data</li>
        <li>Fill Zocks forms using custodial data from Schwab — including holdings, cost basis, and transaction history</li>
      </ul>
    </div>
  )
}
